import loadable from '@loadable/component';

export const GoodtoSiteWrapper = loadable(
  () => import(/* webpackChunkName: "goodto-site" */ './GoodtoSiteWrapper'),
);
